module.exports = __webpack_public_path__ + "static/media/guide_video_thumd.8fa28280.png";